(function(){
if(window._pfXhrPatched)return;window._pfXhrPatched=true;
var _X=window.XMLHttpRequest;
function P(){var x=new _X(),s=this;s._u='';
['timeout','withCredentials','responseType','upload'].forEach(function(p){try{Object.defineProperty(s,p,{get:function(){return x[p]},set:function(v){x[p]=v},configurable:true})}catch(e){}});
['open','setRequestHeader','abort','getResponseHeader','getAllResponseHeaders','overrideMimeType'].forEach(function(m){s[m]=function(){return x[m].apply(x,arguments)}});
s.send=function(b){x.send(b)};
var _op=x.open.bind(x);s.open=function(m,u){s._u=u||'';return _op(m,u)};
function pc(){
  if(x.readyState===4&&x.status>=200&&x.status<300){
    var u=s._u||'';
    if(u.indexOf('cart.js')>-1||u.indexOf('cart.json')>-1){
      try{
        var c=JSON.parse(x.responseText);
        if(c&&c.items){
          var ch=false;
          c.items.forEach(function(i){
            var p=null;
            if(i.properties)Object.keys(i.properties).forEach(function(k){
              if((k==='_design_preview'||k==='design_preview')&&i.properties[k])p=i.properties[k];
            });
            if(p){
              if(!i.product)i.product={};
              i.product.featured_image=p;
              i.image=p;
              if(i.featured_image){i.featured_image.url=p;i.featured_image.src=p;}
              if(!i.variant)i.variant={};
              if(!i.variant.featured_image)i.variant.featured_image={};
              i.variant.featured_image.src=p;
              i.variant.featured_image.url=p;
              ch=true;
            }
          });
          if(ch){
            var pt=JSON.stringify(c);
            Object.defineProperty(x,'responseText',{get:function(){return pt},configurable:true});
            Object.defineProperty(x,'response',{get:function(){return pt},configurable:true});
          }
        }
      }catch(e){}
    }
  }
}
['onreadystatechange','onload','onloadend'].forEach(function(ev){Object.defineProperty(s,ev,{get:function(){return x[ev]},set:function(h){x[ev]=h?function(){pc();h.apply(this,arguments)}:null},configurable:true})});
['ontimeout','onerror','onabort','onloadstart','onprogress'].forEach(function(ev){Object.defineProperty(s,ev,{get:function(){return x[ev]},set:function(v){x[ev]=v},configurable:true})});
['readyState','status','statusText','responseText','response','responseXML'].forEach(function(p){try{Object.defineProperty(s,p,{get:function(){return x[p]},configurable:true})}catch(e){}});
s.addEventListener=function(t,f,o){if(t==='load'||t==='readystatechange'){x.addEventListener(t,function(){pc();f.apply(this,arguments)},o)}else{x.addEventListener(t,f,o)}};
s.removeEventListener=function(){x.removeEventListener.apply(x,arguments)};
s.UNSENT=0;s.OPENED=1;s.HEADERS_RECEIVED=2;s.LOADING=3;s.DONE=4;
}
P.prototype=Object.create(_X.prototype);
window.XMLHttpRequest=P;
})();

(function(){
  if(window._pfCssInjected)return;
  window._pfCssInjected=true;
  var s=document.createElement('style');
  s.textContent='#slidecarthq .item .image{width:100px!important;height:100px!important;min-width:100px!important;flex-shrink:0!important}#slidecarthq .item .image img,#slidecarthq .item img{width:100px!important;height:100px!important;object-fit:contain!important;background:#1a1a1a!important;border-radius:6px!important}';
  document.head.appendChild(s);
})();